
import React from 'react';


import {connect} from 'react-redux';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';


import './sobrenosotros24uu4.scss';


// Hamburger
function loftyInitHam() {
  try {
  // eslint-disable-next-line no-restricted-globals
    window.addEventListener('click', (event) => {
      let originPointLeft = '';
      const comp = event.target.className;
      if (comp.includes('menu__btn') || comp.includes('span_middle') || comp.includes('span_before') || comp.includes('span_after')) {
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        spanData.forEach((item) => {
          originPointLeft = item.style.left;
        });
        res.forEach((item) => {
          item.style.left = '0px';
        });
        spanData.forEach((item) => {
          item.style.left = '-300px';
        });
        closeBtn.forEach((item) => {
          item.style.left = '10px';
        });
      } else {
        if (comp === 'menu__box') {
          return;
        }
        if (comp === 'linkshref') {
          return;
        }
        if (comp === 'menu__item') {
          return;
        }
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        res.forEach((item) => {
          item.style.left = '-300px';
        });
        spanData.forEach((item) => {
          item.style.left = originPointLeft;
        });
        closeBtn.forEach((item) => {
          item.style.left = '-100%';
        });
      }
    });
  } catch (error) {
    // console.log(error);
  }
}    
    




const Psobrenosotros24uu4 = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {





  
  setTimeout(() => { loftyInitHam(); }, 2000);

  
  

  
  return (
    <div id="id67116816a68f26b67983cc92" >

      <div id="iw4j" className="">
      
      <div id="ips2" className="">
      
      <div id="itmdc" className="">
      
      <img
        className=""
        id="ismeq"
        src="https://assetsprojects.s3.amazonaws.com/404m4lim23uvzm3.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="iacot" className="">
      
        <LoftyDropdownComponent
          id="iejkse"
          className="gjs-dropdown-menu-container link-navbar "
          childrenShow={
            <>
              <div id="icmp9k" className="gjs-dropdown-menu-trigger ">
<>Servicios</></div>

            </>
          }
          childrenHover={
            <>
              <div id="ifwrr4" className="gjs-dropdown-menu-content " style={{display: 'block'}}>

      <a
        target=""
        className="link-navbar "
        id="ixxmu"
        href="/tret"
        type="button"
      >
        
    <div id="ikc1x" className="">
    <>TRET</>
    </div>
    
      </a>
      
      <a
        target=""
        className="link-navbar "
        id="i2hsg"
        href="/"
        type="button"
      >
        
    <div id="ij3vk" className="">
    <>CFO Externo</>
    </div>
    
      </a>
      </div>

            </>
          }
        />
        
      <a
        target=""
        className="link-navbar "
        id="ibmm3s"
        href="/sobrenosotros"
        type="button"
      >
        
    <div id="iol6vk" className="">
    <>Sobre Nosotros</>
    </div>
    
      </a>
      
      </div>
      
      <img
        className=""
        id="iok6z3"
        src="https://assetsprojects.s3.amazonaws.com/405opfilkvb1chy.jpg"
        alt="undefined"
      />
      
      <div id="icq3pj" className="">
      
      <div id="" className="contentwrapperanimated ">
      
      <div id="" className="container_animated ">
      
      <label id="" className="menu__btn ">
      
      <span className="span_before " id="">
        
      </span>
      
      <span className="span_middle " id="">
        
      </span>
      
      <span className="span_after " id="">
        
      </span>
      
      </label>
      
      <label id="" className="menu__close__btn ">
      
      <span className="span__close__left " id="">
        
      </span>
      
      <span className="span__close__right " id="">
        
      </span>
      
      </label>
      
      <ul id="" className="menu__box ">
        
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/tret"
        type=""
      >
        <>TRET</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/sobrenosotros"
        type=""
      >
        <>Sobre Nosotros</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      </li>
      
      <li className="linkshref " id="">
        
      </li>
      
      <li className="linkshref " id="">
        
      </li>
      
      </ul>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="ihk8" className="">
      
      <div id="it6xg" className="">
      
      <div className="" id="ip3sl">
        <>Sobre Nosotros</>
      </div>
      
      <div className="" id="ir8ccl">
        <>Servicios &gt; Sobre Nosotros</>
      </div>
      
      <div id="ibin0r" className="">
      
        <a
          target=""
          className="botonprimary "
          id="i1ezla"
          href="#"
        >
          
    <div id="icfw7s" className="">
    <>Contáctanos</>
    </div>
    
        </a>
        
      </div>
      
      </div>
      
      <div id="if5pi" className="">
      
      <div className="" id="i803s">
        <>Con TRET, buscamos brindar a más personas acceso a mejores condiciones para sus recursos. Nuestra herramienta facilitará el ingreso seguro al mercado financiero, con el apoyo de expertos, con el fin de maximizar la rentabilidad de nuestros usuarios</>
      </div>
      
      </div>
      
      </div>
      
      <div id="i6xx" className="">
      
      <div id="i0tfl" className="">
      
      <div id="ivvvb5" className="">
      
      <div id="iyqmu8" className="">
      
      </div>
      
      </div>
      
      <div id="im4sk2" className="">
      
      </div>
      
      </div>
      
      </div>
      
      <div id="isbhos" className="">
      
      <div id="ixm66f" className="">
      
      <div id="ip0maj" className="">
      
      <div className="" id="ienu8f">
        <>Nuestro Equipo de Expertos</>
      </div>
      
      <div className="" id="ina5t7">
        <>Conoce Nuestro Equipo Profesional</>
      </div>
      
      </div>
      
      <div
        id="irvcbs"
        className=""
        data-aos="fade-down"
        data-aos-duration="2000"
      >
      
      <div id="ik1fro" className="">
      
      <div id="ifwury" className="">
      
      <img
        className=""
        id="i3hxlw"
        src="https://assetsprojects.s3.amazonaws.com/405opfilkj42vcp.jpg"
        alt="undefined"
      />
      
      <div id="ilm4cs" className="">
      
      <div className="" id="iqgasl">
        <>Khristian Madrid</>
      </div>
      
      <div className="" id="imr5oa">
        <>Director Ejecutivo</>
      </div>
      
      </div>
      
      </div>
      
      <div id="igl9nt" className="">
      
      <img
        className=""
        id="iv5fji"
        src="https://assetsprojects.s3.amazonaws.com/405opfilkj4knra.jpg"
        alt="undefined"
      />
      
      <div id="iqyff9" className="">
      
      <div className="" id="i4w8fi">
        <>Luis Murcia</>
      </div>
      
      <div className="" id="iiyyr5">
        <>Director Producto</>
      </div>
      
      </div>
      
      </div>
      
      <div id="igfl4q" className="">
      
      <img
        className=""
        id="iuiq1j"
        src="https://assetsprojects.s3.amazonaws.com/405opfilkj4luuc.jpg"
        alt="undefined"
      />
      
      <div id="i1qkbg" className="">
      
      <div className="" id="imtyrx">
        <>Adip Numa</>
      </div>
      
      <div className="" id="id44v6">
        <>Director Financiero</>
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i8y5ds" className="">
      
      <div id="i1rm39" className="">
      
      <div className="" id="iskk6y">
        <>Centro de Ayuda</>
      </div>
      
      <div className="" id="iqw6v3">
        <>Preguntas Frecuentes</>
      </div>
      
      </div>
      
      <div
        id="idba1b"
        className=""
        data-aos="fade-up"
        data-aos-duration="undefined"
      >
      
      </div>
      
      <div id="ipr2hz" className="">
      
      <div id="i34wa4" className="">
      
      <div id="i9wi5g" className="">
      
      <div id="ikc2lc" className="">
      
      <div className="subtitulo " id="iw6ito">
        <>¿Aumentar la rentabilidad implicaría mayores riesgos?</>
      <br className="" id="" />
      
      </div>
      
      <div className="descripcion2 " id="i2rnbz">
        <>Nuestras sugerencias se basan en los productos financieros tradicionales ofrecidos por bancos AAA para optimizar la gestión de la liquidez. Esto se fundamenta en la premisa clave de que la liquidez de la empresa debe ser utilizada en su capital de trabajo.</>
      <br className="" id="" />
      
      </div>
      
      </div>
      
      <div id="iq08vf" className="">
      
      <img
        className=""
        id="iibjh8"
        src="https://assetsprojects.s3.amazonaws.com/404m4lim2dq7kha.jpg"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      <div id="icfmzu" className="">
      
      <div id="i8s6av" className="">
      
      <img
        className=""
        id="irn8im"
        src="https://assetsprojects.s3.amazonaws.com/404m4lim2dq9323.jpg"
        alt="undefined"
      />
      
      </div>
      
      <div id="iq80p1" className="">
      
      <div className="subtitulo " id="il3td7">
        <>¿Para maximizar mi rentabilidad, debo hacer cambio de mis bancos?</>
      <br className="" id="" />
      
      </div>
      
      <div className="descripcion2 " id="iduxjj">
        <>No necesariamente. Sin embargo, nuestra experiencia nos ha demostrado que concentrar todas las finanzas en un solo banco puede resultar en ineficiencias en costos financieros, como tasas de créditos y comisiones en pagos a terceros o nómina, así como en la rentabilidad ofrecida en cuentas de ahorro, CDT, entre otros.</>
      <br className="" id="" />
      
      <br className="" id="" />
      <>Por tanto, diversificar en productos y entidades bancarias termina siendo una estrategia más efectiva para la rentabilidad de la empresa</>
      <br className="" id="" />
      
      <br className="" id="" />
      
      </div>
      
      </div>
      
      </div>
      
      <div id="iufskg" className="">
      
      <div id="i7ls6t" className="">
      
      <div className="subtitulo " id="ih8yyt">
        <>¿Si no tengo Excedentes de caja o hago uso créditos bancarios puedo optimizar mi flujo de caja?</>
      <br className="" id="" />
      
      </div>
      
      <div className="descripcion2 " id="iedmvz">
        <>Las empresas que recurren al crédito para cubrir su faltante de liquidez, a menudo concluyen que no disponen de liquidez para generar una rentabilidad adicional. Sin embargo, tras un análisis inicial, en muchos casos, nos damos cuenta de que existe una liquidez circulante que podría ser optimizar de manera efectiva.</>
      <br className="" id="" />
      
      <br className="" id="" />
      <>Esto permitiría reducir significativamente los costos financieros,y generar mayores ingresos para la empresa</>
      <br className="" id="" />
      
      <br className="" id="" />
      
      </div>
      
      </div>
      
      <div id="i4gp8v" className="">
      
      <img
        className=""
        id="ik0t72"
        src="https://assetsprojects.s3.amazonaws.com/404m4lim2dqa1nt.jpg"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      <div id="i6riff" className="">
      
      <div id="iw9hzs" className="">
      
      <img
        className=""
        id="isjw1g"
        src="https://assetsprojects.s3.amazonaws.com/404m4lim2dqbtyj.jpg"
        alt="undefined"
      />
      
      </div>
      
      <div id="iulp8t" className="">
      
      <div className="subtitulo " id="i07qxl">
        <>¿TRET es una empresa que se dedica a administrar recursos?</>
      <br className="" id="" />
      
      </div>
      
      <div className="descripcion2 " id="ijncn7">
        <>TRET es una empresa que actúa como aliado estratégico para otras compañías, brindando información financiera relevante y valiosa. Nuestra misión es empoderarte para que puedas tomar las mejores decisiones para tu empresa sin perder autonomía en la administración de tus recursos. </>
      <br className="" id="" />
      
      <br className="" id="" />
      <>Nos enfocamos en proporcionarte datos precisos y análisis detallados para que puedas optimizar tus operaciones y alcanzar tus objetivos financieros con confianza. Nuestra colaboración te permitirá tomar decisiones informadas y estratégicas para el crecimiento y éxito de tu negocio.</>
      <br className="" id="" />
      
      <br className="" id="" />
      
      </div>
      
      </div>
      
      </div>
      
      <p className="" id="">
        
      </p>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="icohi" className="">
      
      <div id="iyghfd" className="">
      
      <div id="i52pnr" className="">
      
      <div id="iys268" className="">
      
      <img
        className=""
        id="imi9j3"
        src="https://assetsprojects.s3.amazonaws.com/404m4lim0h22y66.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="iyo7r6">
        <>Externaliza tu CFO con TRET</>
      </div>
      
      <div className="" id="iygu8i">
        
      <a
        target=""
        className=""
        id="ionor8"
        href="mailto:gerencia@tret.com.co"
        type=""
      >
        <>gerencia@tret.com.co</>
      </a>
      
      </div>
      
      </div>
      
      <div id="id3akf" className="">
      
      <div className="" id="i160fk">
        <>Dirección</>
      </div>
      
      <div className="" id="igdgp1">
        <>Carrera 8 #85-31, Bogotá, Colombia</>
      </div>
      
      <div className="" id="io8u0g">
        
      <a
        target=""
        className=""
        id="ivbmuk"
        href="mailto:gerencia@tret.com.co"
        type=""
      >
        <>gerencia@tret.com.co</>
      </a>
      
      </div>
      
      </div>
      
      <div id="ipuzkj" className="">
      
      <div className="" id="ifh7p5">
        <>Contacto</>
      </div>
      
      <div className="" id="il1rnw">
        
      <a
        target=""
        className=""
        id="ic38zj"
        href="mailto:gerencia@tret.com.co"
        type=""
      >
        <>gerencia@tret.com.co</>
      </a>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="iou1pv" className="">
      
      <div className="" id="izq2dp">
        <>Todos lo derechos reservados</>
      </div>
      
      </div>
      
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Psobrenosotros24uu4);
  